// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $ModelCreateParams,
} from 'common.data';

// Global Enums
import {
  RatingType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  ratingTypeLabel,
} from 'common.language';
import config from '../../../config';

// Components
import InputRating from '../../form/InputRating';

// Types
type $Props = $Translate & {
  item: $ModelCreateParams<'Rating'>;
};

type $State = {
  activeRatingType: null | RatingType;
};

class RatingFieldsView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      activeRatingType: props.item.Type,
    };
  }

  render() {
    const {
      item,
      t,
    } = this.props;
    const {
      activeRatingType,
    } = this.state;

    return (
      <>
        <Row>
          <Col>
            <AvField
              disabled={item.ReferenceId}
              label={t('Type')}
              name={'Type'}
              onChange={(e) => {
                const value: null | RatingType = _.get(
                  e.target,
                  'value',
                  null,
                );

                this.setState({
                  activeRatingType: value,
                });
              }}
              required
              type={'select'}
              value={item.Type}
            >
              {_.map(
                RatingType,
                (v, k) => (
                  <option
                    key={k}
                    value={v}
                  >
                    {t(ratingTypeLabel[v])}
                  </option>
                ),
              )}
            </AvField>
          </Col>
          <Col>
            <InputFile
              fileDirUrl={`${config.CDN_URL}/files`}
              label={t('File')}
              labelChangeFile={t('Change file')}
              labelError={t('Error')}
              labelFile={t('File')}
              name={'File'}
              onError={ErrorLog.exception}
              uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
              value={item.File}
            />
          </Col>
        </Row>
        {activeRatingType !== null && (
          <InputRating
            activeRatingType={activeRatingType}
            values={item.Values}
          />
        )}
      </>
    );
  }
}

export default RatingFieldsView;
